require("./_setters.js");
require("babel-polyfill");
require("expose-loader?Tether!tether");
require("../bootstrap/dist/js/bootstrap.js");
require("../bootstrap/js/dist/tooltip");
require("expose-loader?moment!moment");
require("../vendor/jquery.maphilight.min.js");
//require("jquery-easing");
//require("expose-loader?CvrmSearch!./front/search_v1.js");
require("expose-loader?CvrmSearchQuery!./front/search-query.js"); // TEMP
require("expose-loader?CvrmAdditionalCostsFront!./front/additional-costs.js");
require("expose-loader?CvrmBookingCalendar!./front/calendar/CalendarContainerV1.jsx");
require("expose-loader?CvrmStarRating!./front/star-rating.js");
require("expose-loader?CvrmVisitorInformation!./front/visitor-information.js");
require("expose-loader?CvrmVisitorsInformation!./front/visitors-information.js");
require("slick-carousel");
require("slick-carousel/slick/slick.scss");
require("slick-carousel/slick/slick-theme.scss");
require("../sass/front/responsive_v1/styles.scss");
require("../sass/front/responsive_v1/map.scss");
require("./front/readmore.min.js");
require("expose-loader?bootbox!bootbox");
require("./front/discountsignup.js");
require("expose-loader?intlTelInput!intl-tel-input");
require("./React/Render/FrontComponentsRegister.js");
require("expose-loader?Routing!fos-routing");
require("expose-loader?VoltCountryBankSelect!./React/Components/VoltCountryBankSelect/index.js");
